export { default } from './authenticator';
export * from './isNAASupportAvailable';

export const acquireTokenTimeout = 10000;
